import { r as registerInstance, h, H as Host, g as getElement } from './index-aa456b4c.js';

const fdsTextareaCss = ".fds-expander__content{display:block;padding:0 1rem 0.75rem;background-color:white;border-bottom-left-radius:16px;border-bottom-right-radius:16px}.fds-expander__content>*:last-child{margin-bottom:0 !important}.fds-expander__content[hidden]{display:none}.fds__textarea{display:block;margin-bottom:1rem}.fds__textarea .fds__label{cursor:pointer;display:block;display:inline-block;margin-bottom:0.25rem;font-family:IBM-Plex-Sans-VF, Arial, sans-serif;font-weight:bold;font-size:1rem;line-height:1.5;letter-spacing:0}.fds__textarea .fds__label--no-margin{margin-bottom:0}.fds__textarea .fds__hint{font-family:IBM-Plex-Sans-VF, Arial, sans-serif;font-weight:lighter;font-size:1rem;line-height:1.335;letter-spacing:inherit;margin-bottom:0.25rem}.fds__textarea .error-msg{display:none;color:#E31C0D;line-height:1.5;font-size:1rem;margin-top:0.25rem;font-weight:bold}.fds__textarea .input__content{position:relative;display:flex;align-items:center}.fds__textarea .input__content .icon{position:absolute;user-select:none;display:none;justify-content:center;align-items:center;top:0.75rem;right:0.75rem;transform:translateY(0);width:1.5rem;height:1.5rem}.fds__textarea .input__content__value{margin:0 0.5rem;text-align:right}.fds__textarea .input__content textarea{box-sizing:border-box;display:block;width:100%;max-width:100%;min-height:96px;max-height:600px;background-color:white;padding:calc(0.75rem + 1px) 0.75rem;border-radius:4px;border:1px solid rgba(0, 0, 0, 0.4625);color:rgba(0, 0, 0, 0.795);outline:none;font-size:1rem;font-family:IBM-Plex-Sans-VF, Arial, sans-serif;background-clip:padding-box;resize:vertical}.fds__textarea .input__content textarea:focus{border:2px solid #3B87DD;padding:calc(0.75rem) calc(0.75rem - 1px)}.fds__textarea .input__content--focus textarea,.fds__textarea .input__content--hover textarea{border:2px solid #3B87DD;padding:calc(0.75rem) calc(0.75rem - 1px)}.fds__textarea[valid=true] textarea{padding-right:calc(2rem * 1.5)}.fds__textarea[valid=true] .icon{display:flex}.fds__textarea[valid=true] .icon svg{fill:#559C14}.fds__textarea[valid=false] .error-msg{display:block}.fds__textarea[valid=false] textarea{border:2px solid #E31C0D;padding-right:calc(2rem * 1.5)}.fds__textarea[valid=false] textarea:focus{border-color:#E31C0D;padding:calc(0.75rem + 1px) calc(2rem * 1.5) calc(0.75rem + 1px) calc(0.75rem)}.fds__textarea[valid=false] .icon{display:flex}.fds__textarea[valid=false] .icon svg{fill:#E31C0D}.fds__textarea[disabled]{cursor:not-allowed;pointer-events:none;opacity:0.2;user-select:none}";

const FdsTextarea = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.state = 'none';
    this.label = undefined;
    this.meta = undefined;
    this.disabled = false;
    this.valid = undefined;
    this.invalidMessage = undefined;
  }
  handleIcons() {
    if (this.valid === 'true') {
      return h("div", { class: "icon" }, h("fds-icon", { name: "check", size: "24px" }));
    }
    else if (this.valid === 'false') {
      return h("div", { class: "icon" }, h("fds-icon", { name: "alert", size: "24px" }));
    }
  }
  focusInput() {
    this.el.getElementsByTagName('textarea')[0].focus();
  }
  render() {
    const { label, meta, state } = this;
    const showInvalidMsg = (this.valid === 'false' && this.invalidMessage ? true : false);
    const inputEl = this.el.getElementsByTagName('textarea')[0];
    const inputId = inputEl.id;
    function setLabelClasses() {
      const labelClasses = [
        'fds__label',
        (label && meta ? 'fds__label--no-margin' : null)
      ];
      return labelClasses.filter(val => val !== null).join(' ');
    }
    function setStateClass() {
      return state && state !== 'none' ? `input__content--${state}` : null;
    }
    if (!inputId) {
      console.error(`Component [fds-textarea] requires an id.`);
    }
    if (this.label) {
      inputEl.setAttribute('aria-describedby', `aria-${inputId}`);
    }
    return (h(Host, { "aria-disabled": this.disabled ? 'true' : false, class: `fds__textarea` }, this.label
      ? h("label", { id: `aria-${inputId}`, class: `${setLabelClasses()}`, htmlFor: inputId, onClick: () => this.focusInput() }, this.label)
      : null, this.meta
      ? h("div", { class: "fds__hint" }, this.meta)
      : null, h("div", { class: `input__content ${setStateClass()}` }, h("slot", null), this.handleIcons()), showInvalidMsg
      ? h("span", { class: "error-msg", "aria-live": "polite", id: `aria-${inputId}` }, this.invalidMessage)
      : null));
  }
  get el() { return getElement(this); }
};
FdsTextarea.style = fdsTextareaCss;

export { FdsTextarea as fds_textarea };
